const reduceArray = (arr = [], key) => {
  if (arr && !arr.length) return {};
  const arrParams = [...arr];
  const obj = arrParams?.reduce((acc, currentValue) => {
    const accCopy = { ...acc };
    const splitKey = key.split(".");
    if (splitKey.length === 1) {
      accCopy[currentValue?.[key].toLowerCase()] = currentValue;
      return accCopy;
    }
    const usedKey = splitKey.reduce((acc, current) => {
      if (typeof acc !== "object") {
        return acc;
      }
      const value = acc?.[current] || currentValue[current];
      return value;
    }, {});

    accCopy[usedKey] = currentValue;
    return accCopy
  }, {});

  return obj;
};

export default reduceArray;
